/* src/app/app.component.scss */
.main_container .top_nav {
  display: block;
  margin-left: 0px !important;
}
:host ::ng-deep .simple-notification-wrapper {
  width: auto !important;
}
/*# sourceMappingURL=app.component.css.map */
